import Vue from "vue";
import dataFormats from "./dataFormats";
const formats = {
  long: {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  },
  short: {
    year: "numeric",
    day: "numeric",
    month: "numeric"
  }
};
function getLocaleDateFormat(lang) {
  return dataFormats[lang] || "dd/MM/yyyy";
}
const dateTime = {
  install: function(Vue) {
    Vue.prototype.$dateTime = function(
      dateTime,
      format = "long",
      locale = "",
      timeZone = ""
    ) {
      if (!locale) {
        locale = this.$store.getters["profileStore/getDateTimeFormat"];
      }
      if (!formats.hasOwnProperty(format)) {
        format = "long";
      }
      let options = formats[format];
      if (timeZone) {
        options.timeZone = timeZone;
      } else {
        // if we don't set it, it can give last one timezone (project timezone for example)
        options.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      }
      return new Date(dateTime).toLocaleDateString(locale, options);
    };
    Vue.prototype.$getLocaleDateFormat = function(locale) {
      if (!locale) {
        locale = this.$store.getters["profileStore/getDateTimeFormat"];
      }
      return getLocaleDateFormat(locale);
    };
  }
};
Vue.use(dateTime);
export default dateTime;
